import React, {Component} from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'

import Title from 'components/Title'
import Subtitle from 'components/Subtitle'

import styles from './styles.module.css'

class Feature extends Component {
  render() {
    const {title, subtitle, Icon} = this.props

    return (
      <article>
        <Icon className={styles.icon} />
        <Title level={2} type="feature">
          {title}
        </Title>
        <Subtitle type="feature">{subtitle}</Subtitle>
      </article>
    )
  }
}

Feature.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired
}

export default withStyles(styles)(Feature)
